import { render, staticRenderFns } from "./couchbaseDiskUsed.vue?vue&type=template&id=d23ce6a6&scoped=true"
import script from "./couchbaseDiskUsed.vue?vue&type=script&lang=js"
export * from "./couchbaseDiskUsed.vue?vue&type=script&lang=js"
import style0 from "./couchbaseDiskUsed.vue?vue&type=style&index=0&id=d23ce6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23ce6a6",
  null
  
)

export default component.exports